
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.723 22.59c-.236.15-.502.21-.738.21s-.502-.06-.738-.21L7.5 15.29v9.705c0 2.073 1.653 3.756 3.69 3.756h17.62c2.037 0 3.69-1.683 3.69-3.756v-9.705L20.723 22.59z","fill":"#E13131"}}),_c('path',{attrs:{"d":"M28.81 10H11.19c-1.742 0-3.218 1.262-3.572 2.945l12.397 7.692 12.367-7.692C32.028 11.262 30.552 10 28.811 10z","fill":"#E13131"}})])
          )
        }
      }
    